import React, { Component } from 'react';
import '../less/index.less'
import img from '../images/ditu.jpg'
import img1 from '../images/gz.jpg'

class AboutUs extends Component {
    constructor(props) {
		super(props)
		this.state = {}
    }
    
    render() {
        return (
            <div className="About">
                <div className="content1">
                    <p className="biaoti">公司介绍</p>
                    <p>
                    浙江作为中国速递服务行业的发源地，一直以来都是引领速递发展的地区，而同城快递是快递服务最基础的一个类别。十间鱼（2016年起）作为第一批同城速递服务的供应商一直秉承我们的理念把同城速递的服务做好、做优、做精，然做好同城速递服务必须要有一支以“客户至上”为服务理念的专业速递队伍，并需要有着同城速递服务管理的丰富经验，二者缺一不可。我们现有的5000家合作公司与10年服务管理的经验都是我们“做好、做优、做精”信心的来源，您的选择会带给您一个优质的同城速递服务体验，请选择我们——杭州十间鱼科技有限公司
                    </p>
                </div>
                <div className="content1">
                    <p className="biaoti">企业文化</p>
                    <p>
                    对外，成为客户长远互利的好伙伴，<br/>对内，让每一位员工成为彼此最可靠的队友。<br/>灵捷全体同仁，彼此携手，和客户随着时代一起进步，创建双赢的美好未来。
                    </p>
                </div>
                <p className="biaoti">公司位置</p>
				<div className="content2">
                    <div>
                        <img className="callUsImg" src={img} /> 
                    </div>
                    <div className="content2_description">
                        <div>地址: 杭州市滨江区网商路272号 尚坤中控数字园</div><br/>
                        <div>Q Q: 2852375708 </div><br/>
                        <div>联系电话: 0571-85083306</div><br/>
                        <div>售后电话: 0571-85781106</div><br/>
                        <div>技术支持: support@sjychina.com </div>
                        <img src={img1} />
                    </div>
				</div>
			</div>
        )
    }
}

export default AboutUs;